import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Grid, Button } from "@material-ui/core";
import DashboardWrapper from "../containers/DashboardWrapper";
import {
  setCurrentPage,
} from "../actions";
import Period from "../components/Filter/Period";
import FilterApplied from "../components/Filter/FilterApplied";
import DownloadCalendar from "../components/Calendar/DownloadCalendar";
import DownloadTable from "../components/Table/DownloadTable";
import LocalStorageHelper from "../utils/helper/localstorage_helper";

const useStyles = makeStyles((theme) => ({
  contentGrid: {
    marginTop: theme.spacing(1),
    width: "100%%",
  },
  contentGridSlim: {
    marginTop: theme.spacing(1),
    width: "90%",
  },
  root: {
    marginTop: 32,
    minWidth: 275,
  },
  title: {
    fontSize: 14,
  },
  filtered: {
    marginTop: 10,
    marginLeft: 16,
  },
}));

const Download = ({
  setCurrentPage,
  filterStore,
  seasonData,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [downloadImage, setDownloadImage] = useState([]);
  const companyName = LocalStorageHelper.getCompany();

  useEffect(() => {
    setCurrentPage(window.location.pathname);
    let copyFilter = { ...filterStore };
    copyFilter.tag = [];
  }, []);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleImageSelect = (event, value) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setDownloadImage((prev) => [...prev, value]);
    } else {
      setDownloadImage((prev) => prev.filter((url) => url !== value));
    }
  };

  return (
    <DashboardWrapper>
      <Grid container spacing={0} direction="row" justifyContent="center">
        <Grid item xs={12} lg={12}>
          <Grid
            container
            justifyContent={"center"}
            className={open ? classes.contentGridSlim : classes.contentGrid}
          >
            <Grid item xs={12} lg={10}>
              <Grid
                container
                direction="row"
                justifyContent={"space-between"}
                className={open ? classes.contentGridSlim : classes.contentGrid}
              >
                <Grid item>
                  {/* <Period companyName={companyName} /> */}
                </Grid>
                <Grid item>
                  <DownloadCalendar companyName={companyName} />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} lg={10} className={classes.filtered}>
              <DownloadTable
                handleDrawerOpen={handleDrawerOpen}
                handleDrawerClose={handleDrawerClose}
                handleImageSelect={handleImageSelect}
                downloadImage={downloadImage}
                setDownloadImage={setDownloadImage}
                open={open}
                activeDownload={true}
                companyName={companyName}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </DashboardWrapper>
  );
};

Download.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  filterStore: state.home.filter,
  seasonData: state.app.seasonData,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Download);
